import { Validator } from 'vee-validate'

Validator.extend('nameContain', {
  getMessage: field => `The ${  field  } value only contains alphanumeric characters, underscore and dot`,
  validate: value => /^[a-zA-Z0-9._]+$/g.test(value)
})

Validator.extend('No_Start', {
  getMessage: field => `The ${  field  } no _ or . at the beginning`,
  validate: value => /^([^_.].*)/g.test(value)
})

Validator.extend('No_End', {
  getMessage: field => `The ${  field  } no _ or . at the end`,
  validate: value => /(.*[^_.])$/g.test(value)
})

Validator.extend('No__Inside', {
  getMessage: field => `The ${  field  } no __ or _. or ._ or .. inside`,
  validate: value => /^(?!.*[_.]{2}).*$/g.test(value)
})

Validator.extend('glot_email', {
  getMessage: field => `The ${  field  } is not valid`,
  validate: value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(value)
})

Validator.extend('glot_login_acc', {
  getMessage: field => `The ${  field  } is not valid`,
  validate: value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(value) || /^(?=[a-zA-Z0-9._]{3,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/g.test(value)
})